/* eslint-disable no-undef */

class Recaptcha {
  constructor(props) {
    this.config = {
      recaptchaFormButtons: document.querySelectorAll('[data-module="recaptcha"]'),
      key: '',
      ...props
    };
  }

  static findParentByTag(element_, tag) {
    let element = element_;
    while (element.tagName !== tag) {
      element = element.parentNode;
    }
    return element;
  }

  init() {
    const { recaptchaFormButtons, key } = this.config;
    recaptchaFormButtons.forEach(button_ => {
      const button = button_;
      if (button.dataset.initialized) return;

      button.dataset.initialized = true;

      button.insertAdjacentHTML(
        'beforebegin',
        `<div class="grecaptcha-branding">This site is protected by reCAPTCHA and the Google <a href="https://policies.google.com/privacy" target="_blank">Privacy Policy</a> and <a href="https://policies.google.com/terms" target="_blank">Terms of Service</a> apply.</div>`
      );

      const submitInput = document.createElement('button');
      submitInput.type = 'submit';
      submitInput.style.cssText = 'display: none;';

      button.insertAdjacentElement('afterend', submitInput);

      const tokenInput = document.createElement('input');
      tokenInput.type = 'textarea';
      tokenInput.name = 'g-recaptcha-response';
      tokenInput.id = 'g-recaptcha-response';
      tokenInput.style.display = 'none';

      const parentForm = Recaptcha.findParentByTag(button, 'FORM');
      parentForm.appendChild(tokenInput);

      button.addEventListener('click', async e => {
        e.preventDefault();
        const hasParsley = parentForm.classList.contains('js-parsley-form');

        if (hasParsley) {
          $(parentForm)
            .parsley()
            .validate();
        }
        if (!parentForm.checkValidity()) {
          submitInput.click();
          return;
        }
        if (
          hasParsley &&
          !$(parentForm)
            .parsley()
            .isValid()
        )
          return;

        grecaptcha.ready(() => {
          grecaptcha.execute(key, { action: 'backendtoken' }).then(token => {
            tokenInput.value = token;
            submitInput.click();
          });
        });
      });
    });
  }
}

export default Recaptcha;
